module.exports = __webpack_public_path__ + "media/newstyle/images/icon-upload-d2fcf2fa6c441d6275e816d0ceeab37b.svg";